import { createContext } from 'react';
import useModal from '../hooks/use-modal';
import Modal from '../components/UI/Modal/Modal';

let ModalContext;
let { Provider } = (ModalContext = createContext());

const ModalProvider = ({ children }) => {
  const { modal, handleModal, modalContent, modalTitle, modalSubtitle } =
    useModal();
  return (
    <Provider
      value={{ modal, handleModal, modalContent, modalTitle, modalSubtitle }}
    >
      <Modal />
      {children}
    </Provider>
  );
};

// export default { ModalContext, ModalProvider };
export { ModalContext, ModalProvider };
